export default "__VITE_ASSET__DYbbAc31__"